<template>
<div>
  <div style="height:60px" class="hidden-md-and-up"></div>
      <h2>Normativa - Marco Legal</h2>
  <v-layout row wrap>
    <v-flex sm12>
      <v-list three-line :light="true" dense> 
        <div v-for="(item,index) in items" :key="index" >
          <v-list-tile avatar :href="url+item.archivoUrl" target="_blank">
            <v-list-tile-avatar>
              <v-icon color="red">picture_as_pdf</v-icon>
            </v-list-tile-avatar>
            <v-list-tile-content>
              <v-list-tile-title v-html="item.nombre "></v-list-tile-title>
              <v-list-tile-sub-title v-html="`${item.descripcion}<br/><span class='caption'> Fecha Actualizacion : ${formatoFecha(item.fechaUltimaModificacion)}`"></v-list-tile-sub-title>
              
            </v-list-tile-content>
          </v-list-tile>
          <v-divider :inset="true"></v-divider>
        </div>
      </v-list>
    </v-flex>
  </v-layout>
  </div>
</template>
<script>
export default {
  computed:{
    url(){
      return this.$docUrl
    },
    items(){
      return this.$store.state.normativas
    }
  },
  mounted: function() {
    if (this.$vuetify.breakpoint.width > 960) {
      this.$vuetify.goTo(60);
    } else {
      this.$vuetify.goTo(0);
    }
  },
  methods:{
    formatoFecha(date){
     if (!date) return null;
      const [dates, hours] = date.split(" ");
      if (date.indexOf("-") > 0) {
        const [year, month, day] = dates.split("-");
        return `${day}/${month}/${year}`;
      }
      return date; 
    }
  }
};
</script>
<style>
.v-list--three-line .v-list__tile__sub-title {
  /* autoprefixer: ignore next */
  -webkit-box-orient: vertical;
}
</style>





// WEBPACK FOOTER //
// src/components/Normativa/Normativa.vue